import { loggedIn, invoiceSettled } from '../../../routes/conditional';
import paths from '../../../routes/paths';
import {
  clearCheckoutFlow,
} from '../../../redux/modules/checkout';

export const page = {
  path: paths.checkout.complete,
  isAllowed: [loggedIn, invoiceSettled],
};

export const checkoutComplete = {
  actionPath: '/actions/checkout/complete',
  action: () => clearCheckoutFlow(),
};
